import { render } from "./OwnerForm.vue?vue&type=template&id=6d2f2baa"
import script from "./OwnerForm.vue?vue&type=script&lang=js"
export * from "./OwnerForm.vue?vue&type=script&lang=js"

import "./OwnerForm.vue?vue&type=style&index=0&id=6d2f2baa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__